import React, { FC } from 'react'
import { ResourceDemoTagsContainer } from './style'

//* utils
import { ModuleNames } from '../../../constants/componentNames.constants'
import { UIPATH } from '../../../constants/urls'
import { findTarget } from '../../../utils/microcopy.utils'

//* components
import ContentBlock from '../../global/contentBlock'
import Hero from '../../global/hero'
import MainCTA from '../../global/mainCta'
import ResourceRow from '../../global/resourceRow'
import SEOTags from '../../global/seoTags'
import Typography from '../../global/typography'
import VideoSpotlight from '../../global/videoSpotlight'

type Props = {
  data: any
  relatedDemos: any
  dynamicContent: any
  dynamicRow: any
  generics: any
  availableLocales: any
  locale: string
  path: string
  location: any
}

export const Modules: FC<Props> = ({
  data,
  relatedDemos,
  dynamicContent,
  dynamicRow,
  generics,
  availableLocales,
  locale,
  path,
  location,
}) => {
  let dynamicPageContent = data.flexSection?.map((module: any, i: number) => {
    switch (module.__typename) {
      case ModuleNames.GLOBAL_CONTENT_BLOCK:
        return <ContentBlock data={module} useCase="Resource" key={`page-component--${i}`} />

      case ModuleNames.ANCHOR_LINK:
        return <span key={`page-component--${i}`} id={module.identifier || ''}></span>

      case ModuleNames.RESOURCE_ROW:
        return <ResourceRow data={module} key={`page-component--${i}`} locale={locale} />
    }
  })

  if (relatedDemos.length > 0) {
    dynamicPageContent = [
      <ContentBlock data={dynamicContent} useCase="Resource" key="demo_content_block" />,
      <ResourceRow data={dynamicRow} locale={locale} key="demo_resource_row" />,
    ]
  }

  const formattedDemoTopics =
    data.topics?.map((topic: any) => {
      topic.url = topic.title
        ? `/resources/${topic.title
            .toLowerCase()
            .replace(/ *\([^)]*\) */g, '')
            .replace(/\s/g, '-')}`
        : `${UIPATH.PROD}/resources/all`

      return topic
    }) || []

  const renderTopics = () => {
    if (formattedDemoTopics.length > 0) {
      return (
        <ResourceDemoTagsContainer>
          <div className="Tags__Group">
            <Typography type="label" className="Tags__Heading">
              {findTarget(`resource.6.TopicsLABEL.text`, generics) || 'Topics:'}
            </Typography>

            {formattedDemoTopics?.map((tag: any) => {
              if (tag.title) {
                return (
                  <a
                    key={tag.title}
                    className="Tag CustomerStory__Tag"
                    href={`${UIPATH.PROD}/resources/all`}>
                    {tag.title}
                  </a>
                )
              }
            })}
          </div>
        </ResourceDemoTagsContainer>
      )
    }
  }

  return (
    <div data-cy="PageResourceDemoPage">
      <SEOTags
        seoMetadata={data.seoMetadata}
        path={path}
        slug={data.slug || '/'}
        locale={locale}
        siteSection="Resource Demo"
        availableLocales={availableLocales}
      />

      {data.hero && (
        <Hero
          data={data.hero}
          location={location}
          pageTitle={data.pageName || data.name}
          showBreadcrumbs={true}
          locale={locale}
          breadcrumb={data.breadcrumb}
        />
      )}

      {data.spotlight && <VideoSpotlight data={data.spotlight} useCase="Resource" />}
      {dynamicPageContent}
      {renderTopics()}
      {data.bottomCta && <MainCTA data={data.bottomCta} />}
    </div>
  )
}
